import { Switch as MUISwitch } from '@mui/material';
/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback, useMemo } from 'react';
import { useSwitchStyles } from './Switch.styles';
import SwitchCheckIcon from './SwitchCheckIcon';
import SwitchUncheckIcon from './SwitchUncheckIcon';
import { SWITCH_VARIANT_WITH_ICON } from './constants';
export function Switch(props) {
    const { onChange, color = 'secondary', disabled, variant, checked: switchChecked, className, id, testid } = props;
    const classes = useSwitchStyles();
    const displayWithIcon = variant === SWITCH_VARIANT_WITH_ICON;
    const handleOnChange = useCallback((event, checked) => {
        if (onChange) {
            onChange(event, checked);
        }
    }, [onChange]);
    const iconProps = useMemo(() => displayWithIcon
        ? {
            icon: React.createElement(SwitchUncheckIcon, null),
            checkedIcon: React.createElement(SwitchCheckIcon, null),
        }
        : {}, [displayWithIcon]);
    return (React.createElement(MUISwitch, Object.assign({ className: className, checked: switchChecked, color: color, disabled: disabled, id: id, "data-testid": testid, onChange: handleOnChange, classes: {
            colorPrimary: classes.colorPrimary,
            colorSecondary: classes.colorSecondary,
        } }, iconProps)));
}
//# sourceMappingURL=Switch.js.map